/**
 * Format a US phone number for display or progressive typing.
 *
 * Accepts any string (digits-only API values, partially-typed input, formatted
 * strings) and returns `(XXX) XXX-XXXX` for completed numbers or a partial
 * intermediate during typing. Extra digits beyond 10 are dropped.
 */
export function formatPhoneNumber(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 10)
  const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/)
  if (!match) {
    return ''
  }
  const [, area, prefix, line] = match
  if (line) {
    return `(${area}) ${prefix}-${line}`
  }
  if (prefix) {
    return `(${area}) ${prefix}`
  }
  if (area) {
    return `(${area}`
  }
  return ''
}
